<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00008">ILLUSTRATIONS.</h2>
<div class="center">
<table border="0" cellpadding="14" cellspacing="0" class="calibre7" summary="">
<tbody class="calibre8"><tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">the pursuit of the train robber</span></td>
<td class="calibre22"><em class="calibre19"><a class="reference" href="#/Text/Section0002">Frontispiece</a></em></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"></td>
<td class="calibre22"><span class="smcap">page</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">rod blake wins by a length</span></td>
<td class="calibre22"><a class="reference" href="#/Text/Section0006#imgpg15">15</a></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">smiler drives off the tramp</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0011#imgpg55" title="Link target outside of Sample">42</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">in the hands of the enemy</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0016#imgpg97" title="Link target outside of Sample">82</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">rod assists the young man to the “limited”</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0023#imgpg149" title="Link target outside of Sample">132</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">the sheriff hands rod the leather bag</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0034#imgpg221" title="Link target outside of Sample">202</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">in the railroad wreck</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0036#imgpg235" title="Link target outside of Sample">214</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22"></td>
<td class="calibre10"><span class="smcap">“he launched himself forward”</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0040#imgpg263" title="Link target outside of Sample">240</span></td>
</tr>
</tbody>
</table>
</div>
<p class="calibre3"><span id="pgepubid00009" title="[Pg 1]"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?1306b26e